import { getGtag } from "@/components/analytics-pixels";
import { env } from "@tweetdm/env/client";
import { usePostHog } from "posthog-js/react";

export const useLandingConversions = () => {
  const posthog = usePostHog();

  const trackPrimaryCtaClicked = async (location = "cta") => {
    posthog.capture("primary_cta_clicked", { location });
  };

  const trackBookDemoClicked = async (location = "cta") => {
    posthog.capture("book_demo_clicked", { location });

    if (env.NEXT_PUBLIC_GTAG_ID) {
      const gtag = await getGtag();

      gtag("event", "conversion", {
        send_to: `${env.NEXT_PUBLIC_GTAG_ID}/${env.NEXT_PUBLIC_GTAG_BOOK_DEMO_EVENT_ID}`,
      });
    }
  };

  return {
    trackPrimaryCtaClicked,
    trackBookDemoClicked,
  };
};
